import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useQuery } from 'react-admin';
import { getUser } from '../../../../../user';

const ReplacementButton = ({ className, record, formUrl }) => {
  const { data: affectations } = useQuery({
    type: 'getManyReference',
    resource: 'affectation',
    payload: {
      target: 'cleaner_id',
      id: record.id,
      sort: { field: 'id', order: 'DESC' },
      pagination: { page: 1, perPage: 5 },
      filter: { type: 'Permanent', active: true },
    },
  });

  const { data: absence } = useQuery({
    type: 'getManyReference',
    resource: 'affectation',
    payload: {
      target: 'cleaner_id',
      id: record.id,
      sort: { field: 'end_date', order: 'DESC' },
      pagination: { page: 1, perPage: 1 },
      filter: { type: 'Absence', active: true },
    },
  });

  if (!affectations || !absence)
    return (
      <MenuItem>
        <ListItemText primary="loading" />
      </MenuItem>
    );

  return (
    <Fragment>
      <Route
        render={() => {
          const user = getUser();
          return (
            <MenuItem
              className={className}
              variant="contained"
              onClick={() => {
                if (absence.length === 0) {
                  window.alert(
                    "⚠️ Pas d'absence active sur le planning de l'agent",
                  );
                } else {
                  window.open(
                    `${`${`${`${formUrl}context=replacement` +
                      `&cleaner_firstname=${record.firstname}` +
                      `&cleaner_lastname=${record.lastname}` +
                      `&cleaner_id=${record.id}` +
                      `&cleaner_position=Agent d'entretien` +
                      `${
                        absence[0].end_date
                          ? `&cleaner_absence_end_date=${absence[0].end_date}`
                          : ''
                      }` +
                      `&manager_fullname=${user.fullname}` +
                      `&manager_email=${user.email}` +
                      `&manager_id=${user.id}`}${affectations.map(
                      (affectation, index) => {
                        const days = [];

                        return (
                          `&affectation_${index + 1}_start_date=${
                            affectation.start_date
                          }` +
                          `&affectation_${index + 1}_end_date=${
                            affectation.end_date
                          }` +
                          `&affectation_${index + 1}_start_time=${
                            affectation.start_time
                          }` +
                          `&affectation_${index + 1}_end_time=${
                            affectation.end_time
                          }` +
                          `&affectation_${index + 1}_days=${(affectation.monday
                            ? days.push('Lundi')
                            : null,
                          affectation.tuesday ? days.push('Mardi') : null,
                          affectation.wednesday ? days.push('Mercredi') : null,
                          affectation.thursday ? days.push('Jeudi') : null,
                          affectation.friday ? days.push('Vendredi') : null,
                          affectation.saturday ? days.push('Samedi') : null,
                          affectation.sunday ? days.push('Dimanche') : null,
                          days.join(','))}` +
                          `&affectation_${index +
                            1}_account_name=${encodeURIComponent(
                            affectation.account_name,
                          )}` +
                          `&affectation_${index + 1}_site_address=${
                            affectation.site_address
                          }`
                        );
                      },
                    )}`}`}`,
                  );
                }
              }}
            >
              <ListItemText primary="Organiser un remplacement" />
            </MenuItem>
          );
        }}
      />
    </Fragment>
  );
};

ReplacementButton.propTypes = {
  className: PropTypes.string,
  record: PropTypes.object,
  formUrl: PropTypes.string,
};

ReplacementButton.defaultProps = {
  className: undefined,
  record: undefined,
  formUrl: undefined,
};

export default ReplacementButton;
